<template>
  <v-tile :product="product">
    <div class="c-tile__wrapper">
      <v-product-image
        :product="product"
        class="c-tile__image"
      ></v-product-image>
      <v-play-product
        v-if="isPlayable"
        :product="product"
        icon-class="o-icon--play-circle o-icon--xlarge"
        class="o-button--overlay"
      ></v-play-product>
      <v-progress
        v-if="$section.tileProgress"
        :product="product"
        class="c-tile__progress"
      ></v-progress>
      <v-badge
        :product="product"
        class="o-badge--right"
      ></v-badge>
    </div>
    <div class="c-tile__details">
      <h3 class="c-tile__title u-bold">
        {{ product.title }}
      </h3>
      <p class="c-tile__subtitle">
        {{ product | meta(keys) }}
      </p>
      <p class="c-tile__description u-ellipsis-3-lines">
        {{ product.lead | truncate }}
      </p>
    </div>
  </v-tile>
</template>
<script>
  import { VBadge, VPlayProduct, VProductImage, VProgress, VTile } from '@/index/shared/components';
  import { meta, truncate } from '@/index/shared/filters';
  import { productMixin } from '@/index/shared/mixins';

  export default {
    components: {
      VPlayProduct,
      VProductImage,
      VProgress,
      VBadge,
      VTile,
    },
    filters: {
      meta,
      truncate,
    },
    mixins: [
      productMixin,
    ],
    inject: ['$section'],
    props: {
      product: Object,
    },
    computed: {
      keys() {
        return this.product.season.serial.showEpisodeNumber ? ['seriesFormat', 'duration'] : ['duration'];
      },
    },
  };
</script>
